import dayjs from "dayjs";

export function getCookie(name: string) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2)
    return parts.pop()!.split(';').shift();
}

export function parseJwt(token: string) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));
  return JSON.parse(jsonPayload);
}

export function getCountDown(lastSpinISO: string, participationPeriodSeconds: number): string | null {
  const now = dayjs();
  const nextAllowed = dayjs(lastSpinISO).add(participationPeriodSeconds, "second");
  const diffSec = nextAllowed.diff(now, "second");

  if (diffSec <= 0) return null;

  const hours = Math.floor(diffSec / 3600);
  const minutes = Math.floor((diffSec % 3600) / 60);
  const seconds = diffSec % 60;

  const hh = String(hours).padStart(2, "0");
  const mm = String(minutes).padStart(2, "0");
  const ss = String(seconds).padStart(2, "0");

  return `${hh}:${mm}:${ss}`;
}

/**
 * Converts a currency value from wheel currency to user currency if they differ
 * @param value - The value in wheel currency
 * @param wheelCurrency - The wheel's default currency
 * @param userCurrency - The user's currency
 * @param currencyRate - Exchange rate from wheel currency to user currency (optional)
 * @param currencyPrecision - Decimal precision for conversion (optional)
 * @returns The converted value in user currency, or original value if no conversion needed
 */
export function convertCurrency(
  value: number,
  wheelCurrency: string,
  userCurrency: string | null,
  currencyRate?: number,
  currencyPrecision?: number
): number {
  // If currencies are the same or user currency is not available, no conversion needed
  if (!userCurrency || wheelCurrency === userCurrency || !currencyRate) {
    return value;
  }

  // Convert the value
  const convertedValue = value * currencyRate;

  // Apply precision if provided
  if (currencyPrecision !== undefined && currencyPrecision >= 0) {
    const multiplier = Math.pow(10, currencyPrecision);
    return Math.round(convertedValue * multiplier) / multiplier;
  }

  return convertedValue;
}